import Component from "vue-class-component";

// Required for vue-class-component to pick up in-component navigation guards
// (beforeRouteEnter/beforeRouteUpdate/beforeRouteLeave) defined as class methods.
Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate", "beforeRouteLeave"]);
